import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PaymentsService } from '../services';
import { getACHAuthorizationRecordsQueryKey } from './useGetACHAuthorizationRecords';

export const useRevokeACHAuthorization = (userId, options = {}) => {
  const { onSuccess, onError } = options;
  const queryClient = useQueryClient();

  const mutation = useMutation({
    meta: { skipGlobalErrorToaster: true },
    mutationFn: async (bankId) => {
      await PaymentsService.revokeACHAuthorization(bankId);
    },
    onSuccess: (_, bankId) => {
      queryClient.invalidateQueries({
        queryKey: getACHAuthorizationRecordsQueryKey(userId),
      });
      if (onSuccess) {
        onSuccess(bankId);
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return mutation;
};
